import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Player } from 'src/app/features/handball/player/model/player';
import { Card } from 'src/app/features/handball/cards/model/card';
import { SmallCardComponent } from "src/app/features/handball/cards/view/small-card/small-card.component";
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-card-grid',
  standalone: true,
  templateUrl: './card-grid.component.html',
  styleUrl: './card-grid.component.scss',
  imports: [CommonModule, SmallCardComponent, TableModule]
})
export class CardGridComponent {

  @Input() cards: Card[] = []

}
